<!-- Validation Checks Dialog -->
<div class="validation-checks-dialog">
  <!-- Compact Status Header -->
  <div class="status-header mb-4">
    <div class="flex align-items-center gap-3">
      <div class="flex-1">
        <div class="status-message" *ngIf="!isRefreshing">
          <ng-container [ngSwitch]="overallStatus">
            <span *ngSwitchCase="'success'" class="text-green-700"
              >All validation checks passed</span
            >
            <span *ngSwitchCase="'warning'" class="text-yellow-700"
              >Validation passed with warnings</span
            >
            <span *ngSwitchCase="'error'" class="text-red-700"
              >Validation failed - order will not process</span
            >
            <span *ngSwitchDefault class="text-600"
              >Validation status unknown</span
            >
          </ng-container>
        </div>

        <div class="status-message" *ngIf="isRefreshing">
          <p-skeleton width="300px" height="1.5rem" />
        </div>

        <div class="text-xs text-500 mt-1" *ngIf="lastUpdated && !isRefreshing">
          Last checked: {{ getFormattedLastUpdated() }}
        </div>

        <div
          class="text-xs text-500 mt-1"
          *ngIf="!lastUpdated && !isRefreshing"
        >
          No validation checks have been run yet
        </div>

        <div class="mt-1" *ngIf="isRefreshing">
          <p-skeleton width="200px" height="0.875rem" />
        </div>
      </div>

      <!-- Refresh Button -->
      <p-button
        icon="pi pi-refresh"
        label="Refresh Validation"
        [loading]="isRefreshing"
        [disabled]="isRefreshing"
        severity="primary"
        size="small"
        (onClick)="onRefreshValidation()"
      />
    </div>
  </div>

  <!-- Validation Checks List -->
  <div class="validation-checks-list" *ngIf="!isRefreshing">
    <div class="checks-container" *ngIf="validationChecks.length > 0">
      <div
        *ngFor="let check of validationChecks; trackBy: trackByCheckName"
        class="check-item"
        [ngClass]="{
          'check-passed': !check.isCheckFailed && !check.isCheckSkipped,
          'check-failed': check.isCheckFailed && !check.isCheckSkipped,
          'check-skipped': check.isCheckSkipped,
        }"
      >
        <div class="flex align-items-center gap-3">
          <!-- Status Icon -->
          <i [ngClass]="getStatusIcon(check)" class="check-icon"></i>

          <!-- Check Content -->
          <div class="flex-1">
            <div class="check-text">
              <span>{{ getStatusText(check) }}</span>
              <!-- Error Code Link -->
              <a
                *ngIf="check.isCheckFailed && !check.isCheckSkipped"
                [href]="
                  'https://support.autoship.cloud/article/543-scheduled-order-processing-errors'
                "
                target="_blank"
                class="error-code-link"
              >
                <i class="pi pi-external-link"></i>
                ({{ check.processingErrorCode }})
              </a>
            </div>

            <!-- Show/Hide Details Button -->
            <button
              *ngIf="check.additionalErrorText"
              class="details-toggle"
              (click)="toggleDetails(check)"
            >
              <i
                [ngClass]="
                  isShowingDetails(check)
                    ? 'pi pi-chevron-down'
                    : 'pi pi-chevron-right'
                "
              ></i>
              <span>
                {{ isShowingDetails(check) ? "Hide details" : "Show details" }}
              </span>
            </button>

            <!-- Additional Error Text -->
            <div *ngIf="isShowingDetails(check)" class="error-details">
              {{ check.additionalErrorText }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Skeletons -->
  <div class="validation-checks-list" *ngIf="isRefreshing">
    <div class="checks-container">
      <div class="check-item" *ngFor="let item of [1, 2, 3, 4, 5]">
        <div class="flex align-items-center gap-3">
          <p-skeleton shape="circle" size="1.5rem" />
          <div class="flex-1">
            <p-skeleton width="70%" height="1.2rem" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Shipping Warnings Section -->
  <div *ngIf="shippingWarnings.length > 0 && !isRefreshing" class="mt-4">
    <p-message
      *ngFor="let warning of shippingWarnings"
      severity="warn"
      [text]="warning"
      styleClass="mb-2"
    />
  </div>
</div>
